S.text =
    {
        config: {
            xx: null,
        },

        elements: {
            $xx: null,
        },

        init()
        {
            this.findLinks();
        },

        findLinks()
        {
            let textLi = '';
            let pos = '';

            this.$module.find('li').each((index, item) =>
            {
                textLi = $(item).html();
                pos = textLi.indexOf('<a ');

                if (pos === 0)
                {
                    $(item).addClass('m-icon');
                }
            });
        },
    };
